import React, { useState, useEffect } from "react";
import { getData, postData } from "../../components/helpers/Data";
import MessageModal from "../../components/helpers/Modal2";
import { userSaveDetails } from "../../components/helpers/UserSaveDetails";

const ChangePassword = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(9);

  //module variables
  const [users, setUsers] = useState([]);
  const [messageModal, setIsMessageModal] = useState(false);
  const [response, setResponse] = useState(false);

  useEffect(() => {
    getData("fetch_user_names")
      .then((data) => {
        console.log(data);
        setUsers(data);
      })
      .catch((error) => console.log(error));
  }, []);

  const savePasswordChange = (e) => {
    e.preventDefault();
    const new_pass = document.getElementById("new_password").value;
    const confirm_pass = document.getElementById("confirm_new_password").value;
    if (new_pass == confirm_pass) {
      const frmData = new FormData(
        document.getElementById("change_password_form")
      );

      //append access log details
      frmData.append("user_id", logData[0]);
      frmData.append("accessed_item", logData[1]);
      frmData.append("browser_type", logData[2]);
      frmData.append("os_type", logData[3]);

      postData(frmData, "update_password")
        .then((data) => {
          console.log(data[0]);
          setResponse(data[0]);
          setIsMessageModal(true);
        })
        .catch((error) => console.log(error));
    } else {
      setResponse("Confirm and new password do not match!");
      setIsMessageModal(true);
    }
  };
  //close message modal
  const closeMessageModal = () => {
    setIsMessageModal(false);
    if (response.includes("successfully")) {
      window.location.replace("/change-password");
    }
  };
  return (
    <div>
      <section id="changepassword" className="project-tab">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <hr />
              <form
                className="claims_form mt-1"
                id="change_password_form"
                onSubmit={savePasswordChange}
              >
                <fieldset>
                  <div id="invoice_details_1">
                    <h2 className="fs-title">Password Change</h2>
                    <hr />
                  </div>
                  <div className="row gap-3">
                    <select
                      className="form-control-sm"
                      name="user_name"
                      id="user_name"
                      required="true"
                      defaultValue="0"
                    >
                      <option disabled value="0">
                        Select Username
                      </option>
                      {users.map((data) => {
                        return (
                          <option value={data.user_name}>
                            {data.user_name}
                          </option>
                        );
                      })}
                    </select>

                    <input
                      type="password"
                      className="form-control"
                      name="new_password"
                      id="new_password"
                      placeholder="New Password"
                      aria-required="true"
                      maxlength="5"
                    />

                    <input
                      type="password"
                      className="form-control"
                      name="confirm_new_password"
                      id="confirm_new_password"
                      placeholder="Confirm New Password"
                      aria-required="true"
                      maxlength="5"
                    />
                    <p>
                      <input
                        type="submit"
                        className="btn-success col-4"
                        value="Save"
                      />
                    </p>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/*Message modal*/}
      <MessageModal
        modalIsOpen={messageModal}
        closeModal={closeMessageModal}
        background="#0047AB"
        body={<p className="text-white font-weight-bold h4">{response}</p>}
      />
    </div>
  );
};

export default ChangePassword;
